import React from 'react';
import { useParams } from 'react-router-dom';
import { getMovementBySlug } from '../config/movements';
import GalleryPage from '../components/GalleryPage';

const MovementGalleryPage = () => {
  const { slug } = useParams();
  const movement = getMovementBySlug(slug);

  // Handle case where movement is not found
  if (!movement) {
    return (
      <GalleryPage
        title="Movement Not Found"
        description="The requested movement could not be found."
        images={[]}
        backButtonText="← Back to Our Movements"
        backButtonLink="/#movements"
      />
    );
  }

  // Convert movement images to gallery format
  const galleryImages = movement.images.map((src, index) => ({
    src,
    alt: `${movement.name} ${index + 1}`
  }));

  // Format the title with proper ® symbol handling
  const formatTitle = (name) => {
    if (name.includes('®')) {
      return name.replace('®', '<sup>®</sup>').toLowerCase().replace(/^\w/, c => c.toUpperCase());
    }
    return name.toLowerCase().replace(/^\w/, c => c.toUpperCase());
  };

  return (
    <GalleryPage
      title={<span dangerouslySetInnerHTML={{ __html: formatTitle(movement.name) }} />}
      description={movement.description}
      images={galleryImages}
      backButtonText="← Back to Our Movements"
      backButtonLink="/#movements"
    />
  );
};

export default MovementGalleryPage;